import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Button from './button';
import { AiOutlineRight } from "react-icons/ai";


function Awards(props) {
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <div className='awards'>
            <Slider {...settings} className='awards-slider'>
                {props.awardContent.as_award_media_rep.map((items, index) =>
                    <div className='awards-slider__items' key={index}>
                        <img src={items.as_images} alt='images' />
                    </div>
                )}

            </Slider>

            <div className="awards-content">
            <div dangerouslySetInnerHTML={{ __html: props.awardContent.as_award__description }}></div>
                <div className="btn-wrap">
                    <a href={props.awardContent.as_award_button.url} target="_blank" rel="noreferrer">
                        <Button
                            extraClass='btn-primary'
                            buttonText={props.awardContent.as_award_button.title}
                            btnIcon={<AiOutlineRight />}
                        />
                    </a>
                </div>
            </div>

        </div>
    );
}

export default Awards;

